var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6156 8.14084H16.8469V7.49823C16.8469 6.30523 16.3365 5.16108 15.4278 4.3175C14.5191 3.47392 13.2867 3 12.0017 3C10.7167 3 9.48426 3.47392 8.5756 4.3175C7.66694 5.16108 7.15646 6.30523 7.15646 7.49823V8.14084H4.38775H3.92291C3.67814 8.14084 3.44339 8.23111 3.27031 8.39179C3.09724 8.55247 3 8.7704 3 8.99764L3.0034 9.42604L3.00336 20.1432C3.00336 20.3704 3.10059 20.5884 3.27367 20.749C3.44675 20.9097 3.68149 21 3.92626 21L17.8852 20.9929H20.069C20.3138 20.9929 20.5485 20.9027 20.7216 20.742C20.8947 20.5813 20.9919 20.3634 20.9919 20.1361L21 18.1514V9.42604V8.99097C21 8.76373 20.9028 8.5458 20.7297 8.38512C20.5566 8.22444 20.3219 8.13417 20.0771 8.13417L19.6156 8.14084ZM9.55448 5.22628C8.90544 5.82884 8.54081 6.64608 8.54081 7.49823V8.14084H15.4626V7.49823C15.4626 6.64608 15.098 5.82884 14.4489 5.22628C13.7999 4.62372 12.9196 4.28521 12.0017 4.28521C11.0838 4.28521 10.2035 4.62372 9.55448 5.22628Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.33635e3d7552fbe5dbb9d4668cdb1de8.svg";
export { ForwardRef as ReactComponent };